import Uuid from '../Uuid';
import UserRole from './UserRole';

interface CurrentUserDetail {
  uuid?: Uuid,
  meno?: string,
  organizaciaUuid?: Uuid,
  organizaciaMeno?: string,
  opravnenia?: Array<UserRole>,
  isPovinnyPripomienkovatel?: boolean,
  isDalsiPripomienkovatel?: boolean,
  isOdoslaneBezPripomienok?: boolean,
  pripomienkaExistsForUserOrg?: boolean,
}

export default CurrentUserDetail;

export function hasRole(user: CurrentUserDetail, role: UserRole): boolean {
  return user && user.opravnenia.includes(role);
}
